export const isDevEnv = () => {
  let isDevEnvEnabled = window.env && window.env.IS_DEV_ENV

  /*eslint-disable */
  return isDevEnvEnabled
    ? isDevEnvEnabled != 'false' &&
        (isDevEnvEnabled == 'true' || isDevEnvEnabled)
    : false
  /* eslint-enable */
}

function appUrl() {
  return {
    rootUrl: process.env.APP_ROOT_URL,
    baseUrl: process.env.APP_BASE_URL,
    productName: process.env.APP_PRODUCT_NAME,
  }
}

const app = appUrl()

export default app
